<!-- @Description 加入我们 -->
<template>
  <div class="addUs">
    <div class="addUs-info">
      <div class="addUs-info-title">加入我们</div>
      <div class="addUs-info-content">
        我们将为你提供一个崭新的平台，让你可以充分发挥自己的潜力，成就你一生的事业。
      </div>
      <a class="addUs-info-email" href="mailto:hr@unidt.com">hr@unidt.com</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "addUs"
};
</script>
<style lang="less" scoped>
.addUs {
  width: 100%;
  padding: 96px 0px;
  height: calc(100vh - 636px);
  background: #F3F6FB;

  .addUs-info {
    height: 100%;
    background: url("../../../static/img/about/about_bg.png") no-repeat;
    background-size: contain;
    overflow: hidden;
    background-position-y: bottom;
    text-align: center;
    padding: 48px 68px 64px;

    .addUs-info-title {
      font-size: 44px;
      color: #08204d;
      line-height: 60px;
    }

    .addUs-info-content {
      margin-top: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: left;
    }

    .addUs-info-email {
      display: inline-block;
      margin-top: 48px;
      font-size: 32px;
      font-weight: 400;
      line-height: 52px;
      color: #002fa7;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/addUs/index.vue